import React from "react";
import { NavLink, withRouter } from "react-router-dom";
import { connect } from "react-redux";
import { makeStyles } from "@material-ui/core/styles";
import * as commonActions from "../../../store/common/actions";
import ShoppingCartIcon from "@material-ui/icons/ShoppingCart";
import EnglishToPersian from "../../../components/UI/helpers/EnglishToPersian";
import { useSpring, animated } from "react-spring";
import _ from "lodash";

const Toolbar = (props) => {
  const motion = useSpring({
    from: { top: -100 },
    to: { top: 0 },
    config: {
      duration: 400,
    },
  });
  const dark = props.OffsetToChangeToolbarTheme >= props.scrollPosition;
  const styles = makeStyles((theme) => ({
    root: {
      position: "fixed",
      // top: 0,
      width: "100%",
      zIndex: 100,
      transition: ".3s",
      // borderBottom: dark ? "" : "1px solid #ddd",
      boxShadow: dark ? "" : "0 1px 2px 2px #EfEfEf",
      backgroundColor: dark ? null : "rgba(255, 255, 255, 0.92)",
      "& ul": {
        height: 75,
        alignItems: "center",
        listStyle: "none",
        display: "flex",
        justifyContent: "center",
        padding: 0,
        margin: "auto",
      },
      "& ul li , ul li a": {
        cursor: "pointer",
        color: dark ? "#FFF" : "#000",
      },
    },
    cart: {
      color: "#FFF!important",
      display: "flex",
      padding: "4px 10px!important",
      margin: "0 10px",
      backgroundColor: theme.palette.primary.main,
      borderRadius: 10,
    },
    center: {
      position: "absolute",
      fontWeight: "bold",
      fontSize: 18,
      "@media(max-width:600px)": {
        display: "initial",
      },
    },
    side: {
      display: "flex",
      position: "absolute",
      left: 20,
      "& li": {
        padding: "0 10px",
      },
      "@media(max-width:600px)": {
        display: "none",
      },
    },
    logo: {
      width: 120,
      position: "absolute",
      right: 30,
      top: "20px",
      "@media(max-width:600px)": {
        right: 10,
      },
    },
    mobile: {
      display: "flex",
      position: "absolute",
      left: 20,
      "@media(max-width:600px)": {
        left: 5,
      },
      "& li": {
        padding: "0 10px",
      },
    },
    badge: {
      display: "inline-flex",
      justifyContent: "center",
      alignItems: "center",
      fontSize: 12,
      backgroundColor: theme.palette.primary.main,
      borderRadius: "100%",
      width: 22,
      height: 22,
      color: "#FFF",
      textAlign: "center",
      marginLeft: 4,
    },
  }));
  const classes = styles();
  let newCart = [];
  props.cart &&
    props.cart.forEach((p) => {
      if (p.Count) newCart.push(p);
    });
  const store =
    props.route.params &&
    props.route.params.store_name &&
    props.route.params.store_id;
  const cart =
    props.is_auth && store ? (
      <React.Fragment>
        <li className={classes.cart} onClick={() => props.toggleCart(true)}>
          <span style={{ paddingRight: 4 }}>
            {EnglishToPersian(props.cart.length ? newCart.length : 0)}
          </span>
          <ShoppingCartIcon />
        </li>
      </React.Fragment>
    ) : null;

  const categories = store ? (
    <li>
      <NavLink
        to={
          "/store/" +
          props.route.params.store_name +
          "/" +
          props.route.params.store_id +
          "/categories"
        }
      >
        <span className={"icon-297"}></span>
        دسته بندی
      </NavLink>
    </li>
  ) : null;

  const messages = props.is_auth ? (
    <li>
      <NavLink to={"/account/info"}>
        {props.user && props.user.MessageUnreadCount ? (
          <span className={classes.badge}>
            {EnglishToPersian(props.user && props.user.MessageUnreadCount)}
          </span>
        ) : null}
        پروفایل
      </NavLink>
    </li>
  ) : null;

  const login = !props.is_auth ? (
    <li onClick={() => props.toggleRegisterDialog()}>
      <div style={{ marginRight: 20 }}>ورود</div>
    </li>
  ) : null;
  return (
    <React.Fragment>
      <animated.nav className={classes.root} style={{ top: motion.top }}>
        <ul>
          <li className={classes.logo}>
            <NavLink exact to={"/"}>
              <img
                alt={"logo"}
                style={{ position: "absolute", top: 0 }}
                width="90"
                src={dark ? "/images/logo_light.svg" : "/images/logo_dark.svg"}
              />
            </NavLink>
          </li>
          {store && (
            <React.Fragment>
              <li className={classes.center}>
                <NavLink
                  to={
                    "/store/" +
                    props.route.params.store_name +
                    "/" +
                    props.route.params.store_id
                  }
                >
                  <span className={"icon-297"}></span>
                  {props.route.params.store_name.replace(/-/g, " ")}
                </NavLink>
              </li>
              <div className={classes.mobile}>{cart}</div>
            </React.Fragment>
          )}
          <div className={classes.mobile}>{login}</div>
          <div className={classes.side}>
            {messages}
            {categories}
            {login}
            {cart}
          </div>
        </ul>
      </animated.nav>
    </React.Fragment>
  );
};

const setStore = (dispatch) => {
  return {
    toggleRegisterDialog: (res) =>
      dispatch(commonActions.toggleRegisterDialog(res)),
    toggleCart: (res) => dispatch(commonActions.toggleCart(res)),
  };
};

const getStore = (state) => {
  return {
    user: state.auth.user,
    is_auth: state.auth.is_auth,
    token: state.auth.token,
    width: state.common.size.width,
    scrollPosition: state.common.scrollPosition,
    OffsetToChangeToolbarTheme: state.common.OffsetToChangeToolbarTheme,
    cart: state.auth.cart,
  };
};
export default connect(getStore, setStore)(withRouter(Toolbar));
